<template>
    <div class="">
        <ContainerTitle icon="head-brain" title="Beneficiário"/>
        
        <div class="historico-beneficiario pt-0 pb-3 ">
            <HistoricoBeneficiarioFilter  :empresaOptions="empresaOptions" :cleanFilter="cleanFilter" @filter-historico-beneficiario="filtrar" />
            <HistoricoBeneficiarioList :rows="rows" @filtrar="filtrar(actualFilter)"/>
            <ModalAlert id="historico-beneficiario-list-vazio" @close="$bvModal.hide('historico-beneficiario-list-vazio')">
                <DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
                Não existe beneficiários para o(s) filtro(s) selecionado(s).
            </ModalAlert>
            
            <PaginationTable :page="page" :totalPages="result.totalPages" :totalItens="result.totalItens" @changePage="changePage" />
        </div>        
    </div>
</template>
<script>

import HistoricoBeneficiarioFilter from './components/HistoricoBeneficiarioFilter.vue'
import HistoricoBeneficiarioList from './components/HistoricoBeneficiarioList.vue'
import ModalAlert from "../../../../commons/ModalAlert.vue"
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import UserResource from "@/resources/UserResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ContainerTitle from "@/components/commons/ContainerTitle.vue";
import PaginationTable from "@/components/commons/table/components/PaginationTable.vue";
import { formateTipo, formateDate, formateHours } from "./../../../../../util/BeneficiarioUtils.js";


export default {
    name: 'HistoricoBeneficiario',
    components: {
       HistoricoBeneficiarioList,
       HistoricoBeneficiarioFilter,
       ModalAlert,
       DynamicIcon,
       ContainerTitle,
       PaginationTable
    },
	data() {
		return {
            rows: [],
            result: {
				list: [],
				totalPages: 0,
				totalItens: 0
			},
            historicoIdEdition: null,
			historicoIdDeletion: null,
			historicoPerfisEdition: null,
			showModalForm: null,
			page: 1,
            cleanFilter: false,
            empresaOptions: [],
            actualFilter: null
		}
	},
    methods: {	
		changePage( page ){
			this.page = page
			this.filtrar(this.actualFilter)
		},
        filtrar(formFilter) 
        {
            if(formFilter == undefined) {
               formFilter = {status: 1}
            }

            this.actualFilter = formFilter
			let filter = {
				page: this.page,
				...formFilter
			}

			BeneficiarioImportacaoResource.getHistoricoBeneficiario(filter, {showLoader: true})
			.then((result) => {

                this.result = result
                
                if(!Array.isArray(result.list))
                {
                    this.rows = [];
                }

                if(!result.list.length)
                {
                    this.$bvModal.show("historico-beneficiario-list-vazio");
                }
                
                this.rows = result.list.map( elem =>  { 
                    return {
                        ...elem,
                        tipo: formateTipo(elem.tipoId, elem.flgTitularDependente),
                        data: formateDate(elem.acao == 'INATIVAR' ? elem.dataInativo : elem.dataAtualizacao),
                        hora: formateHours(elem.acao == 'INATIVAR' ? elem.dataInativo : elem.dataAtualizacao), 
                        responsavel: elem.usuario,
                        status: this.formatStatus(elem.flgAtivacao),
                    }
                })
			})
            .catch(()=>{
                this.rows = []
            })
		},
        resetFilter()
        {
            this.cleanFilter = !this.cleanFilter
        },
        formatStatus(status)
        {
            if(status == 1)
                return "Ativo"
            
            return "Inativo"
        }, 
    },
    mounted() {
        UserResource.empresa(null,{ showLoader: false}).then(result => {
            if(Array.isArray(result))
            {
                this.empresaOptions = result.map(elem => { return {value: elem.id, text: elem.text } } )
            }
            
            this.filtrar();
        })
    }
}

</script>

<style scoped>
.historico-beneficiario {
	justify-content: space-between;
    color: #707070;
	font-size: 18px;
	text-align: left;
    background-color: #fff;
}

.total-itens{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.5% 0 0 1.2%;
    color: #002677;
    align-items:flex-start;
}
</style>